import React, { useCallback } from 'react';
import type { FC } from 'react';
import InkTextInput from 'ink-text-input';

interface Props {
  initialValue: boolean;
  onSubmit: (value: boolean) => void;
}

export const Input: FC<Props> = ({ initialValue, onSubmit }) => {
  const handleChange = useCallback(
    (rawKey: string) => {
      const key = rawKey.toLowerCase();
      if (['y', 'n'].includes(key)) {
        onSubmit(key === 'y');
      }
    },
    [onSubmit]
  );

  return (
    <InkTextInput
      value=""
      showCursor={false}
      onChange={handleChange}
      onSubmit={() => onSubmit(initialValue)}
    />
  );
};
